<script setup>
defineProps({
  tag: {
    type: String,
    default: 'p'
  },
  textClass: {
    type: [Array, Object, String]
  }
})
</script>

<template>
  <li role="presentation">
    <component
      :is="tag"
      class="t-dropdown-text"
      :class="[textClass]"
    >
      <slot></slot>
    </component>
  </li>
</template>

<style scoped lang="scss">
.t-dropdown-text {
  color: var(--p-gray-400);
  display: inline-block;
  padding: 0.25rem 0.25rem;
  margin-bottom: 0;
  width: 100%;
  clear: both;
}
</style>
